import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@mdx-js/react'

import DocsLayout from '~layouts/DocsLayout'
import ALFIReleases from '~partials/docs/releases/ALFI'
import LinuxReleases from '~partials/docs/releases/Linux'
import WindowsReleases from '~partials/docs/releases/Windows'

const DocArticle = ({
  data: { article },
  pageContext: { nodeType, breadcrumbs },
}) => (
  <DocsLayout article={article} nodeType={nodeType} breadcrumbs={breadcrumbs}>
    <MDXProvider
      components={{
        ALFIReleases,
        LinuxReleases,
        WindowsReleases,
      }}
    >
      <MDXRenderer>{article.body}</MDXRenderer>
    </MDXProvider>
  </DocsLayout>
)

DocArticle.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default DocArticle

export const pageQuery = graphql`
  query DocsArticleSingle($fileAbsolutePath: String!) {
    article: mdx(fileAbsolutePath: { eq: $fileAbsolutePath }) {
      ...DocsArticlesSingleFragment
    }
  }
`
